import { render } from "./CreationDate.vue?vue&type=template&id=28be45cc&lang=pug"
import script from "./CreationDate.vue?vue&type=script&lang=js"
export * from "./CreationDate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__